import { ScholarshipManagementDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScholarshipManagementService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getScholarshipManagement(): Observable<ScholarshipManagementDto[]> {
    return this.http.get<ScholarshipManagementDto[]>(
      this.url + 'scholarship-management'
    );
  }

  createScholarshipManagement(
    data: ScholarshipManagementDto
  ): Observable<ScholarshipManagementDto> {
    const formData = new FormData();

    formData.append('id', data.id);
    formData.append('StudentPassport', data.StudentPassport);
    formData.append('Address', data.Address);
    formData.append('BeneficaryFirstname', data.BeneficaryFirstname);
    formData.append('BeneficaryOthername', data.BeneficaryOthername);
    formData.append('BeneficarySurname', data.BeneficarySurname);
    formData.append('Community', data.Community);
    formData.append('ContactEmail', data.ContactEmail);
    formData.append('ContactPerson', data.ContactPerson);
    formData.append('ContactPhoneNo', data.ContactPhoneNo);
    formData.append('ContactEmailOnAward', data.ContactEmailOnAward);
    formData.append('ContactPersonOnAward', data.ContactPersonOnAward);
    formData.append('ContactPhoneNoOnAward', data.ContactPhoneNoOnAward);
    formData.append('ContactUrlOnAward', data.ContactUrlOnAward);
    formData.append('CourseOfStudy', data.CourseOfStudy);
    formData.append('DateOfBirth', data.DateOfBirth);
    formData.append('Gender', data.Gender);
    formData.append(
      'InstitutionAddressBeforeAward',
      data.InstitutionAddressBeforeAward
    );
    formData.append(
      'InstitutionAddressOnAward',
      data.InstitutionAddressOnAward
    );
    formData.append(
      'InstitutionCommunityBeforeAward',
      data.InstitutionCommunityBeforeAward
    );
    formData.append(
      'InstitutionCommunityOnAward',
      data.InstitutionCommunityOnAward
    );
    formData.append(
      'InstitutionCountryIdBeforeAward',
      data.InstitutionCountryIdBeforeAward
    );
    formData.append(
      'InstitutionCountryIdOnAward',
      data.InstitutionCountryIdOnAward
    );
    formData.append(
      'InstitutionLGABeforeAward',
      data.InstitutionLGABeforeAward
    );
    formData.append('InstitutionLGAOnAward', data.InstitutionLGAOnAward);
    formData.append(
      'InstitutionNameBeforeAward',
      data.InstitutionNameBeforeAward
    );
    formData.append('InstitutionNameOnAward', data.InstitutionNameOnAward);
    formData.append(
      'InstitutionStateIdBeforeAward',
      data.InstitutionStateIdBeforeAward
    );
    formData.append(
      'InstitutionStateIdOnAward',
      data.InstitutionStateIdOnAward
    );
    formData.append('LGA', data.LGA);
    formData.append('PhoneNumber', data.PhoneNumber);
    formData.append('RemarksBeforeAward', data.RemarksBeforeAward);
    formData.append('RemarksOnAward', data.RemarksOnAward);
    formData.append('ScholarshipApplicationNo', data.ScholarshipApplicationNo);
    formData.append(
      'ScholarshipAwardDurationId',
      data.ScholarshipAwardDurationId
    );
    formData.append('ScholarshipAwardNo', data.ScholarshipAwardNo);
    formData.append('ScholarshipCategoryId', data.ScholarshipCategoryId);
    formData.append('ScholarshipDate', data.ScholarshipDate.toString());
    formData.append('ScholarshipManagementId', data.ScholarshipManagementId);
    formData.append('ScholarshipStatus', data.ScholarshipStatus);
    formData.append('ScholarshipTypeId', data.ScholarshipTypeId);
    formData.append('ScholarshipYear', data.ScholarshipYear);
    formData.append('School', data.School);
    formData.append('State', data.State);
    return this.http.post<ScholarshipManagementDto>(
      this.url + 'scholarship-management/new',
      formData
    );
  }

  uploadExcelScholarshipManagement(
    data: ScholarshipManagementDto[]
  ): Observable<ScholarshipManagementDto[]> {
    return this.http.post<ScholarshipManagementDto[]>(
      this.url + 'scholarship-management/upload',
      data
    );
  }

  getSingleScholarshipManagement(id: string): Observable<any> {
    return this.http.get(this.url + 'scholarship-management/' + id);
  }

  updateScholarshipManagement(
    data: ScholarshipManagementDto
  ): Observable<ScholarshipManagementDto> {
    const formData = new FormData();

    formData.append('id', data.id);
    formData.append('StudentPassport', data.StudentPassport);
    formData.append('Address', data.Address);
    formData.append('BeneficaryFirstname', data.BeneficaryFirstname);
    formData.append('BeneficaryOthername', data.BeneficaryOthername);
    formData.append('BeneficarySurname', data.BeneficarySurname);
    formData.append('Community', data.Community);
    formData.append('ContactEmail', data.ContactEmail);
    formData.append('ContactPerson', data.ContactPerson);
    formData.append('ContactEmailOnAward', data.ContactEmailOnAward);
    formData.append('ContactPersonOnAward', data.ContactPersonOnAward);
    formData.append('ContactPhoneNoOnAward', data.ContactPhoneNoOnAward);
    formData.append('ContactUrlOnAward', data.ContactUrlOnAward);
    formData.append('ContactPhoneNo', data.ContactPhoneNo);
    formData.append('CourseOfStudy', data.CourseOfStudy);
    formData.append('DateOfBirth', data.DateOfBirth);
    formData.append('Gender', data.Gender);
    formData.append(
      'InstitutionAddressBeforeAward',
      data.InstitutionAddressBeforeAward
    );
    formData.append(
      'InstitutionAddressOnAward',
      data.InstitutionAddressOnAward
    );
    formData.append(
      'InstitutionCommunityBeforeAward',
      data.InstitutionCommunityBeforeAward
    );
    formData.append(
      'InstitutionCommunityOnAward',
      data.InstitutionCommunityOnAward
    );
    formData.append(
      'InstitutionCountryIdBeforeAward',
      data.InstitutionCountryIdBeforeAward
    );
    formData.append(
      'InstitutionCountryIdOnAward',
      data.InstitutionCountryIdOnAward
    );
    formData.append(
      'InstitutionLGABeforeAward',
      data.InstitutionLGABeforeAward
    );
    formData.append('InstitutionLGAOnAward', data.InstitutionLGAOnAward);
    formData.append(
      'InstitutionNameBeforeAward',
      data.InstitutionNameBeforeAward
    );
    formData.append('InstitutionNameOnAward', data.InstitutionNameOnAward);
    formData.append(
      'InstitutionStateIdBeforeAward',
      data.InstitutionStateIdBeforeAward
    );
    formData.append(
      'InstitutionStateIdOnAward',
      data.InstitutionStateIdOnAward
    );
    formData.append('LGA', data.LGA);
    formData.append('PhoneNumber', data.PhoneNumber);
    formData.append('RemarksBeforeAward', data.RemarksBeforeAward);
    formData.append('RemarksOnAward', data.RemarksOnAward);
    formData.append('ScholarshipApplicationNo', data.ScholarshipApplicationNo);
    formData.append(
      'ScholarshipAwardDurationId',
      data.ScholarshipAwardDurationId
    );
    formData.append('ScholarshipAwardNo', data.ScholarshipAwardNo);
    formData.append('ScholarshipCategoryId', data.ScholarshipCategoryId);
    formData.append('ScholarshipDate', data.ScholarshipDate.toString());
    formData.append('ScholarshipManagementId', data.ScholarshipManagementId);
    formData.append('ScholarshipStatus', data.ScholarshipStatus);
    formData.append('ScholarshipTypeId', data.ScholarshipTypeId);
    formData.append('ScholarshipYear', data.ScholarshipYear);
    formData.append('School', data.School);
    formData.append('State', data.State);
    return this.http.post<ScholarshipManagementDto>(
      this.url + 'scholarship-management/update',
      formData
    );
  }

  deleteScholarshipManagement(id: any) {
    return this.http.delete(this.url + 'scholarship-management/' + id);
  }
}
